import * as Sentry from "@sentry/react";
import Cookies from 'js-cookie'

const useSubmitProviderFeedback = () => {
    return async (fields, feedbackIDFull, recaptchaToken) => {
        const formData = {
            score: fields.rating.value,
            feedback_key: feedbackIDFull,
            message: fields.comment.value,
            g_recaptcha: recaptchaToken
        };

        const additionalHeaders = {}

        const csrfTokenCookie = Cookies.get('csrftoken')

        if (csrfTokenCookie) {
            additionalHeaders['X-CSRFToken'] = csrfTokenCookie
        }

//         document.cookie.split(';').find((val, index) => {
//             if (val.includes('csrftoken')) {
//                 additionalHeaders['X-CSRFToken'] = val.split('=')[1]
//             }
//         })

        let response;

        try {
            response = await fetch(
                `${process.env.REACT_APP_API_URL}/feedback/`,
                {
                    method: 'POST',
                    headers: {
                        'Access-Control-Request-Method': 'POST',
                        'content-type': 'application/json',
                        ...additionalHeaders
                    },
                    body: JSON.stringify(formData)
                }
            );
        } catch (error) {
            Sentry.captureException(error);
            console.log(error);
            error.clientStatusMessage = {
                variant: 'danger',
                i18nKey: 'error.api-connection-timeout',
                source: `${error.message}`
            }
            throw error;
        }

        let parsedResponse;
        try {
            parsedResponse = await response.json();
        } catch (error) {
            Sentry.captureException(error);
            error.clientStatusMessage = {
                variant: 'danger',
                i18nKey: 'error.api-bad-response',
                source: `${response.status} ${response.statusText}`
            }
            throw error;
        }

        if (response.status !== 201) {
            const error = new Error();
            switch (response.status) {
                case 400:
                case 415: {
                    const feedbackKeyErrors = parsedResponse?.feedback_key || [];
                    const nonFieldErrors = parsedResponse?.non_field_errors || [];
                    const alreadySubmitted =
                        feedbackKeyErrors.includes('feedback_key already used') ||
                        nonFieldErrors.includes('feedback_key already used');

                    error.clientStatusMessage = alreadySubmitted ? {
                        variant: 'warning',
                        i18nKey: 'AddProviderFeedback.message-already-submitted',
                        source: 'Feedback link has already been used.'
                    } : {
                        variant: 'danger',
                        i18nKey: 'error.client-bad-request',
                        source: `${response.status.toString()} ${parsedResponse.detail}`
                    }
                    Sentry.captureException(parsedResponse);
                    break;
                }
                default:
                    error.clientStatusMessage = {
                        variant: 'danger',
                        i18nKey: 'error.api-bad-response',
                        source: `${response.status.toString()} ${parsedResponse.detail}`
                    }
                    Sentry.captureException(parsedResponse);
            }
            throw error;
        }

        return parsedResponse;
    }
}

export default useSubmitProviderFeedback;
